import chartIcon       from '../../../../asset-controller-mod/asset-serv/images/chart.png';
import rocketIcon      from '../../../../asset-controller-mod/asset-serv/images/rocket.png';
import infoIcon        from '../../../../asset-controller-mod/asset-serv/images/info.png';
import calendarIcon    from '../../../../asset-controller-mod/asset-serv/images/calendar.png';
import closeCircleIcon from '../../../../asset-controller-mod/asset-serv/images/close-circle.png';
import { MediaStatItem } from '../../../../component-controller-mod/component-serv/dashboard-fs-cp/media-dsb-op/media-chart/ts/mediaChart';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface StatCard {
  id:          string;
  label:       string;
  value:       number;
  color:       string;
  gradient:    string;
  borderColor: string;
  iconSrc:     string;
  iconAlt:     string;
}

export interface BarData {
  label: string;
  value: number;
  max:   number;
}

export interface MediaLegendItem {
  label: string;
  value: number;
  color: string;
}

export interface InboxLegendItem {
  label: string;
  value: number;
  color: string;
}

export interface DashboardOverview {
  jobPost: {
    total:      number;
    opening:    number;
    active:     number;
    closed:     number;
    reviewed:   number;
    submission: number;
  };
  inbox: {
    total:     number;
    bussiness: number;
    sale:      number;
  };
  media: {
    total:  number;
    image:  number;
    video:  number;
    active: number;
    inused: number;
    unused: number;
  };
  workflow: {
    total:     number;
    published: number;
    unpublish: number;
    draft:     number;
    schedule:  number;
    reject:    number;
  };
}

// ─── Static fallback stat cards ───────────────────────────────────────────────

export const STAT_CARDS: StatCard[] = [
  { id: 'total',     label: 'Total',     value: 0, color: '#2388FF', gradient: 'linear-gradient(88.49deg, #4A95ED 0%, #97CCF3 100%)',     borderColor: '#4A95ED', iconSrc: chartIcon,        iconAlt: 'Chart icon'        },
  { id: 'published', label: 'Published', value: 0, color: '#8A38F5', gradient: 'linear-gradient(89.62deg, #8A38F5 0%, #BB8AFA 100%)',     borderColor: '#8A38F5', iconSrc: rocketIcon,       iconAlt: 'Rocket icon'       },
  { id: 'draft',     label: 'Draft',     value: 0, color: '#8A8B8F', gradient: 'linear-gradient(88.49deg, #C8C8C8 0%, #DCDDDD 100%)',     borderColor: '#C8C8C8', iconSrc: infoIcon,         iconAlt: 'Info icon'         },
  { id: 'unpublish', label: 'Unpublish', value: 0, color: '#09A788', gradient: 'linear-gradient(94deg, #09A788 3.27%, #3CD5B7 97.19%)',   borderColor: '#09A788', iconSrc: calendarIcon,     iconAlt: 'Calendar icon'     },
  { id: 'schedule',  label: 'Schedule',  value: 0, color: '#FF9416', gradient: 'linear-gradient(89.62deg, #FF9416 0%, #F5B76F 100%)',     borderColor: '#FF9416', iconSrc: calendarIcon,     iconAlt: 'Calendar icon'     },
  { id: 'reject',    label: 'Reject',    value: 0, color: '#FF2D46', gradient: 'linear-gradient(88.58deg, #FF475D 0.13%, #FF888F 100%)',  borderColor: '#FF475D', iconSrc: closeCircleIcon,  iconAlt: 'Close circle icon' },
];

// ─── Factory functions ────────────────────────────────────────────────────────

export function buildStatCards(overview: DashboardOverview): StatCard[] {
  return [
    { id: 'total',     label: 'Total',     value: overview.workflow.total,     color: '#2388FF', gradient: 'linear-gradient(88.49deg, #4A95ED 0%, #97CCF3 100%)',    borderColor: '#4A95ED', iconSrc: chartIcon,       iconAlt: 'Chart icon'        },
    { id: 'published', label: 'Published', value: overview.workflow.published, color: '#8A38F5', gradient: 'linear-gradient(89.62deg, #8A38F5 0%, #BB8AFA 100%)',    borderColor: '#8A38F5', iconSrc: rocketIcon,      iconAlt: 'Rocket icon'       },
    { id: 'draft',     label: 'Draft',     value: overview.workflow.draft,     color: '#8A8B8F', gradient: 'linear-gradient(88.49deg, #C8C8C8 0%, #DCDDDD 100%)',    borderColor: '#C8C8C8', iconSrc: infoIcon,        iconAlt: 'Info icon'         },
    { id: 'unpublish', label: 'Unpublish', value: overview.workflow.unpublish, color: '#09A788', gradient: 'linear-gradient(94deg, #09A788 3.27%, #3CD5B7 97.19%)',  borderColor: '#09A788', iconSrc: calendarIcon,    iconAlt: 'Calendar icon'     },
    { id: 'schedule',  label: 'Schedule',  value: overview.workflow.schedule,  color: '#FF9416', gradient: 'linear-gradient(89.62deg, #FF9416 0%, #F5B76F 100%)',    borderColor: '#FF9416', iconSrc: calendarIcon,    iconAlt: 'Calendar icon'     },
    { id: 'reject',    label: 'Reject',    value: overview.workflow.reject,    color: '#FF2D46', gradient: 'linear-gradient(88.58deg, #FF475D 0.13%, #FF888F 100%)', borderColor: '#FF475D', iconSrc: closeCircleIcon, iconAlt: 'Close circle icon' },
  ];
}

export function buildBarData(overview: DashboardOverview): BarData[] {
  const total = overview.jobPost.total || 1;
  return [
    { label: 'Job Opening',     value: overview.jobPost.opening,    max: total },
    { label: 'Active Jobs',     value: overview.jobPost.active,     max: total },
    { label: 'Close Jobs',      value: overview.jobPost.closed,     max: total },
    { label: 'Awaiting review', value: overview.jobPost.reviewed,   max: total },
    { label: 'Submission',      value: overview.jobPost.submission, max: total },
  ];
}

export function buildMediaLegend(overview: DashboardOverview): MediaLegendItem[] {
  return [
    { label: 'Image', value: overview.media.image, color: '#2388FF' },
  ];
}

export function buildMediaStats(overview: DashboardOverview): MediaStatItem[] {
  return [
    { label: 'In use', value: overview.media.inused },
    { label: 'Unused', value: overview.media.unused },
  ];
}

export function buildInboxLegend(overview: DashboardOverview): InboxLegendItem[] {
  return [
    { label: 'Business', value: overview.inbox.bussiness, color: '' },
    { label: 'Sale',     value: overview.inbox.sale,      color: '' },
  ];
}

// ─── Footer links ─────────────────────────────────────────────────────────────

export const MEDIA_FOOTER_LINK = {
  label: 'Total of all Media asset library',
  href:  '/media',
};

export const INBOX_FOOTER_LINK = {
  label: 'Total of all inbox',
  href:  '/inbox',
};